import type { HTMLAttributes } from 'react';
import type { PaginationData } from '..';

export type EducatorReviewCategory = 'humanContact' | 'cleaning' | 'followup' | 'wellBeing';
export interface EducatorReviewListData {
  items: EducatorReviewItemData[];
  amount?: number;
  average?: number;
  loading?: boolean;
  pagination?: PaginationData;
}

export interface EducatorReviewItemData {
  name?: string;
  image?: string;
  description?: string;
  average?: number;
  date?: string;
  verified?: boolean;
}

export interface EducatorReviewListProps
  extends HTMLAttributes<HTMLDivElement>,
    EducatorReviewListData {}
